
import React from 'react';
import { Link } from 'react-router-dom';
import { Building, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from "@/components/auth/AuthProvider";

interface ClaimingSuccessNoticeProps {
  centerName: string;
}

export function ClaimingSuccessNotice({ centerName }: ClaimingSuccessNoticeProps) {
  const { user } = useAuth();
  
  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
      <div className="flex items-center gap-2 text-green-700 font-medium mb-2">
        <span className="inline-block w-5 h-5 rounded-full bg-green-500 mr-1 align-middle" />
        <span>Verified Profile</span>
      </div>
      <p className="text-sm text-green-600 mb-3">
        This is a verified nursing home profile on Grandpal.
      </p>
      
      {user && (
        <Button 
          asChild 
          variant="outline" 
          size="sm" 
          className="w-full border-green-300 text-green-700 hover:bg-green-100 hover:text-green-800"
        >
          <Link to="/owner/dashboard" className="inline-flex items-center">
            <Building className="h-3.5 w-3.5 mr-2" />
            Manage Owner Dashboard
            <ArrowRight className="h-3.5 w-3.5 ml-auto" />
          </Link>
        </Button>
      )}
    </div>
  );
}
